import React from 'react';
import { motion } from 'framer-motion';
const DiscoveryTile = ({ icon, title, description, bgColor, borderColor, textColor, hoverBgColor, iconBgColor, onClick, tabValue, setActiveTabStart, style, isHome }) => {
    // Wrapper function for logging
    const handleClick = () => {
        console.log(`[DiscoveryTile] Clicked tile: "${title}". Has onClick prop: ${!!onClick}`);
        if (onClick) {
            //onClick(); // Call the original onClick passed down
            setActiveTabStart(tabValue);
            onClick();
        }
    };

    return (
        <>

            {style === 'tile' && (
                <>
                    <motion.div
                        className={`bg-black/20 rounded-lg overflow-hidden hover:bg-black/30 transition-colors duration-300 ${borderColor}xx border-black/10 border    cursor-pointer group`}
                        onClick={handleClick} // Use the logging handler
                        whileHover={{ scale: 1.01 }}
                        transition={{ duration: 0.2 }}
                    >
                        <div className={`${bgColor}xx p-4`}>
                            <div className="flex items-center justify-between">
                                <div className="flex items-center gap-3">
                                    <div className={`${iconBgColor}   p-2 rounded-md`}>
                                        <img src={icon} className="h-7 w-7" alt={title} />
                                    </div>
                                    <h3 className={`text-lg font-normal ${textColor}  `}>{title}</h3>
                                </div>
                                <div className={`text-2xl -mt-2 font-normal ${textColor} opacity-30 group-hover:opacity-100 transition-opacity duration-300`}>+</div>
                            </div>
                        </div>
                        <div className="px-5 pb-5 pt-2">
                            <p className="text-zinc-300 group-hover:text-zinc-100 transition-colors duration-150">{description}</p>
                        </div>
                    </motion.div>
                </>
            )}
            {style === 'icons' && (
                <>
                    <motion.div
                        className={`bg-black/10 rounded-lg overflow-hidden hover:bg-black/20 transition-colors duration-300 ${borderColor} cursor-pointer group`}
                        onClick={handleClick} // Use the logging handler
                        whileHover={{ scale: 1.03 }}
                        transition={{ duration: 0.2 }}
                    >
                        <div className={`${bgColor}xxx p-2`}>
                            <div className="flex items-center justify-between">
                                <div className="flex items-center gap-1">
                                    <div className={`${iconBgColor}x p-2 rounded-md`}>
                                        <img src={icon} className={`${isHome ? 'h-7 w-7' : 'h-6 w-6'} opacity-80 group-hover:opacity-100 transition-opacity duration-300`} alt={title} />
                                    </div>
                                    <h3 className={`${isHome ? 'text-base' : 'text-sm'} font-normal ${textColor} opacity-90 group-hover:opacity-100 transition-opacity duration-300`}>{title}</h3>
                                </div>
                            </div>
                        </div>
                    </motion.div>
                </>
            )}
            {style === 'icons-only' && (
                <>
                    <motion.div
                        className={`bg-black/10 rounded-lg overflow-hidden hover:bg-black/5 transition-colors duration-300 ${borderColor} cursor-pointer group ${isHome ? 'h-12 w-12' : 'h-10 w-10'} flex items-center justify-center`}
                        onClick={handleClick} // Use the logging handler
                        whileHover={{ scale: 1.03 }}
                        transition={{ duration: 0.2 }}
                    >
                        <div className={`${bgColor}xxx p-0`}>
                            <div className="flex items-center justify-center">
                                <div className={`${iconBgColor}x p-0 rounded-md`}>
                                    <img src={icon} className={`${isHome ? 'h-7 w-7' : 'h-6 w-6'}`} alt={title} />
                                </div>
                                {/* <h3 className={`text-sm font-normal ${textColor}`}>{title}</h3> */}
                            </div>
                        </div>
                    </motion.div>
                </>
            )}

        </>
    );
};

export default DiscoveryTile;